<template>

<aside class="main-sidebar">
    <!-- sidebar: style can be found in sidebar.less -->
    <section class="sidebar">
        <!-- Sidebar user panel -->
        <div class="user-panel">
            <div class="pull-left image">
                <img
                    src="../../assets/dist/img/UDR_LOGO.png"
                    class="img-circle"
                    alt="User Image"
                >
            </div>
            <div class="pull-left info">
                <p>{{name}}</p>
            </div>
        </div>

        <ul
            class="sidebar-menu"
            data-widget="tree"
        >
            <li class="header">{{ $t('MAIN_NAVIGATION') }}</li>

            <li class="treeview">

                <router-link to="#">
                    <i class="fa fa-bar-chart"></i>
                    <span> {{ $t('TRANSACTION_CREDITCARD_LOG') }} </span>
                    <span class="pull-right-container">
                  <span class="label label-primary pull-right"><!--Aca un num o algo asi --></span>
                    </span>
                </router-link>

                <ul class="treeview-menu">
                    <li>
                        <router-link to="/home"><i class="fa fa-circle-o"></i>  {{ $t('TRANSACTION_TYPE.ALL')}}  </router-link>
                    </li>
                    <li>
                        <router-link to="/transactions/approveds"><i class="fa fa-circle-o text-green"></i> {{ $t('TRANSACTION_TYPE.APPROVED')}} </router-link>
                    </li>
                    <li>
                        <router-link to="/transactions/no-request"><i class="fa fa-circle-o text-aqua"></i>  {{ $t('TRANSACTION_TYPE.WITH_OUT_PETITION')}}  </router-link>
                    </li>
                    <li>
                        <router-link to="/transactions/pendings"><i class="fa fa-circle-o text-yellow"></i>  {{ $t('TRANSACTION_TYPE.SLOPES')}}  </router-link>
                    </li>
                    <li>
                        <router-link to="/transactions/rejected"><i class="fa fa-circle-o text-red"></i>  {{ $t('TRANSACTION_TYPE.REJECTED')}}  </router-link>
                    </li>

                </ul>

            </li>

             <li class="treeview" v-if="this.roll =='develop'">

                <router-link to="#">
                    <i class="fa fa-line-chart"></i>
                    <span> {{ $t('TRANSACTION_LOG') }} </span>
                    <span class="pull-right-container">
                  <span class="label label-primary pull-right"><!--Aca un num o algo asi --></span>
                    </span>
                </router-link>

                <ul class="treeview-menu">
                    <li>
                        <router-link to="/transactionslog"><i class="fa fa-circle-o"></i>  {{ $t('TRANSACTIONLOG_TYPE.ALL')}}  </router-link>
                    </li>
                    <li>
                        <router-link to="/transactionslog/approveds"><i class="fa fa-circle-o text-green"></i> {{ $t('TRANSACTIONLOG_TYPE.APPROVED')}} </router-link>
                    </li>
                    <li>
                        <router-link to="/transactionslog/no-request"><i class="fa fa-circle-o text-aqua"></i>  {{ $t('TRANSACTIONLOG_TYPE.WITH_OUT_PETITION')}}  </router-link>
                    </li>
                    <li>
                        <router-link to="/transactionslog/pendings"><i class="fa fa-circle-o text-yellow"></i>  {{ $t('TRANSACTIONLOG_TYPE.SLOPES')}}  </router-link>
                    </li>
                    <li>
                        <router-link to="/transactionslog/rejected"><i class="fa fa-circle-o text-red"></i>  {{ $t('TRANSACTIONLOG_TYPE.REJECTED')}}  </router-link>
                    </li>

                </ul>

            </li>


            <li  class="treeview" v-if="this.roll =='Administrator'">
                <a href="#">
                      <i class="fa fa-user"></i>
                      <span> {{ $t('USERS.USERS')}} </span>
                      <span class="pull-right-container">
                        <i class="fa fa-angle-left pull-right"></i>
                      </span>
                    </a>
                <ul class="treeview-menu">
                    <li>
                        <router-link to="/users"><i class="fa fa-users text-aqua"></i> {{ $t('USERS.ALL')}} </router-link>
                    </li>
                    <li>
                        <router-link to="/users/create"><i class="fa fa-user-plus text-green"></i> {{ $t('USERS.CREATE')}} </router-link>
                    </li>
                   
                </ul>
            </li>
            </ul>
    </section>
    <!-- /.sidebar -->
</aside>
</template>


<script>
export default {
    name: "Derecha",
    created () {
      
        setInterval( ()=>{
        this.inf();
          }, 100);
    },
    data() {
        return {
            name: "",
            roll:''
        };
    },
    methods: {
        inf() {
          
            let self = this;
            let user = JSON.parse(self.$store.state.user);
            user = user != null ?
                user.payload :
                "";
                  self.name = user.name + " " + user.lastname;
                  self.roll=user.roll;
          
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/layout/Derecha.vue